var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-lg-row flex-md-row flex-sm-column flex-column justify-content-center"},[_c('EmployeeVerificationEmployeeInformation'),_c('transition',{attrs:{"name":"slide-fade"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }